import React, { useState, useMemo, useEffect } from 'react';
import { Typography, TextField, Button, Grid, IconButton, InputAdornment, Paper, Divider, List, ListItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { Header } from '@backstage/core-components';
import QuickAccessGrid from './QuickAccessGrid';
import { makeStyles } from '@material-ui/core';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef } from '@backstage/core-plugin-api';
import { terraformApiRef } from '@internal/plugin-terraform/src/api';
import axios from 'axios';
import { Box, Link } from '@mui/material';
import { CircularProgress } from '@material-ui/core';

// To add additional category on homepage tool section , add category in data.
// To add icons within category , add an object under tools in below format 
let data = [
  {
    category: "DEVELOPER LINKS",
    tools: [
      {
        name: 'Github',
        icon: <GitHubIcon />,
        url: 'https://github.com/'
      },
      {
        name: 'LinkedIn',
        icon: <LinkedInIcon />,
        url: 'https://in.linkedin.com'

      },
    ]
  },
  {
    category: "CI/CD",
    tools: [
      {
        name: 'Kubernetes',
        icon: <GroupWorkIcon width={24} height={24} />,
        url: 'https://kubernetes.io'
      },
    ]
  },
]

const useStyles = makeStyles({
  searchButton: {
    borderRadius: '25px', height: '46px', width: '100%'
  },
  grid1: {
    marginTop: '35px'
  },
  grid2: {

  },
  grid3: {
    paddingBottom: '20px'
  },
  favoriteGrid: {
    marginTop: '70px',
  },
  quickAccessPaper: {
    padding: '20px', height: '70%'
  },
  entitiesPaper: {
    padding: '20px'
  },
  entitiesText: {
    fontSize: '18px', fontWeight: 700
  },
  lodaingStatusBox: {
    display: 'flex', justifyContent: 'flex-end'
  },
  loadingText: {
    marginLeft: '8px', paddingRight: '8px'
  },
  linkText: {
    fontSize: '16px', fontWeight: 700
  },
  link: {
    color: '#1F5493'
  }
})

function Homepage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [org, setOrg] = useState('')
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const api = useApi(terraformApiRef);
  const styles = useStyles();
  const [gitlink, setGitlink] = useState('')
  const [accountName, setAccountName] = useState('')
  const discoveryApi = useApi(discoveryApiRef)
  const [loading, setLoading] = useState(true)
  const [tfOrgName, setTFOrgName] = useState('')
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef)
  const [tenantId, setTenantId] = useState<string | null>(null);

  useEffect(() => {
    // get tenantId from identityApi
    const fetchTenant = async () => {
      try {
        const details = await identityApi.getBackstageIdentity();
        const id = details.ownershipEntityRefs.find(ref =>
          ref.startsWith('tenantId:')
        )?.split(':')[1] || null;
        setTenantId(id);
      } catch (err) {
        console.error('Failed to get tenantId:', err);
        setTenantId(null);
      }
    };

    fetchTenant();
  }, [identityApi]);

  useEffect(() => {
    fetchData();
  }, [tenantId])

  useEffect(() => {
    if (gitlink && tenantId) {
      const key = `githubOrgName:${tenantId}`;
      localStorage.setItem(key, gitlink);
    }
  }, [gitlink, tenantId]);

  const fetchData = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      // const organizationData = await axios.get(`${baseUrl}/homepage-data`);

      let data = []
      try {
        const fetchresponse = await fetchApi.fetch(`${baseUrl}/homepage-data`, {
          method: 'GET',
        });
        if (!fetchresponse.ok) {
          const errorText = await fetchresponse.text();
          throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
        }
        data = await fetchresponse.json();
        console.log('Fetched data:', data);
      } catch (error) {
        console.error('Fetch or JSON parse error:', error);
      }

      setTFOrgName(data?.homepageData?.tfOrganization)
      setGitlink(data?.homepageData?.gitOrganization)
      setAccountName(data?.masterAccountName)
      setLoading(false)
    }
    catch (error) {
      setLoading(false)
    }
  }

  const handleSearchChange = (event: any) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setSearchQuery(searchQuery)
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        if (!tenantId) {
          setOrg('');
          return;
        }

        const cacheKey = `orgName:${tenantId}`;
        const cachedOrg = localStorage.getItem(cacheKey);
        if (cachedOrg) {
          setOrg(cachedOrg);
          return;
        }

        const response = await api.fetchOrgDetails(tenantId);
        if (!response || !response.data) {
          setOrg("");
          return;
        }

        const orgDetail = response.data.orgDetail;
        if (orgDetail) {
          localStorage.setItem(cacheKey, orgDetail);
          setOrg(orgDetail);
        } else {
          setOrg("");
        }
      } catch (err) {
        console.error("Failed to fetch org details:", err);
        setOrg("");
      }
    };

    fetchUserInfo();
  }, [tenantId]);


  return (
    <div style={containerStyle}>
      <div>
        <Header title={`Welcome to CloudOPS`} subtitle={`${org}`} />
      </div>
      <div>{loading ? (
        <Box className={styles.lodaingStatusBox}>
          <CircularProgress size={20} />
          <Typography className={styles.loadingText}>
            Loading
          </Typography>
        </Box>
      )
        :
        (<Box sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          p: 2,

        }}>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1" className={styles.linkText}>Github :</Typography>
            <Link className={styles.link} href={`https://github.com/${gitlink}`} target="_blank" rel="noopener">
              {`https://github.com/${gitlink}`}
            </Link>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1" className={styles.linkText}>Terraform Cloud :</Typography>
            <Link className={styles.link} href={`https://app.terraform.io/app/${tfOrgName}`} target="_blank" rel="noopener">
              {`https://app.terraform.io/app/${tfOrgName}`}
            </Link>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1" className={styles.linkText}>AWS Account : {`${accountName ? accountName : ''}`}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body1" className={styles.linkText}>TF Organization Name : {`${tfOrgName ? tfOrgName : ''}`}</Typography>
          </Box>
        </Box>)
      }
      </div>
      <Grid container direction="column" spacing={2} className={styles.grid1}>
        {/* <Grid item xs={12} md={8} className={styles.grid2} >
          <Grid container spacing={2} alignItems="center" className={styles.grid3}>
            <Grid item xs={9}>
              <TextField
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
                onKeyDown={handleSearchChange}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchQuery && (
                        <IconButton onClick={handleClearSearch} edge="end">
                          <ClearIcon />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: '25px', // Round the search bar
                    height: '48px' // Adjusting the height of the search bar
                  }
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Button type="submit" variant="contained" color="primary" onClick={handleSubmit} className={styles.searchButton}>
                Search
              </Button>
            </Grid>
          </Grid>
      </Grid> */}
        <Grid item container spacing={2} justifyContent="center" xs={12} md={8} >
          <Grid item xs={6} className='quick-access-div'>
            <Grid item className={styles.grid2} >
              <Grid container spacing={2} className={styles.grid3}>
                <Grid item xs={9}>
                  <TextField
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onKeyDown={handleSearchChange}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {searchQuery && (
                            <IconButton onClick={handleClearSearch} edge="end">
                              <ClearIcon />
                            </IconButton>
                          )}
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: '25px', // Round the search bar
                        height: '48px' // Adjusting the height of the search bar
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Button type="submit" variant="contained" color="primary" onClick={handleSubmit} className={styles.searchButton}>
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Paper elevation={3} className={styles.quickAccessPaper}>
              <QuickAccessGrid searchQuery={searchQuery} data={data} />
            </Paper>
          </Grid>
          <Grid item xs={5} className={styles.favoriteGrid}>
            <Paper elevation={3} className={styles.entitiesPaper}>
              <Typography className={styles.entitiesText} gutterBottom>
                Favourites
              </Typography>
              <Divider />
              <List>
                <ListItem>
                  Click the star besides the entity to add it to this list.
                </ListItem>
              </List>
            </Paper>
          </Grid>
        </Grid>

      </Grid>
    </div>

  );
}

export default Homepage;
